import { render, staticRenderFns } from "./SiteNavDesktopV2.vue?vue&type=template&id=21efa278&scoped=true&lang=pug"
import script from "./SiteNavDesktopV2.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopV2.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopV2.vue?vue&type=style&index=0&id=21efa278&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21efa278",
  null
  
)

export default component.exports